<template>
  <tr>
    <td>
      <strong>{{ line.description }}</strong><br>
      <span class='grey--text' v-html='line.notes'></span>
    </td>
    <td width='120' class='text-right'>
      <v-btn x-small icon color='orange' @click="$emit('lineClick', line)">
        <v-icon small color='orange'>
          mdi-pencil
        </v-icon>
      </v-btn>
      <v-btn x-small icon color='red' @click="$emit('deleteLine', line)">
        <v-icon small color='red'>
          mdi-delete
        </v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'estimate-line-item',
  props: {
    line: {
      required: true
    },
    isLast: {
      required: false
    }
  }
}
</script>
